export const LANGUAGES = [
  // Tier 1 - most demanded
  { flag: "🇬🇧", name: "English", th: "อังกฤษ", cert: "NAATI / MoJ / Notary", tier: 1 },
  { flag: "🇨🇳", name: "中文", th: "จีนกลาง/กวางตุ้ง", cert: "Embassy Certified", tier: 1 },
  { flag: "🇯🇵", name: "日本語", th: "ญี่ปุ่น", cert: "Embassy Verified", tier: 1 },
  { flag: "🇰🇷", name: "한국어", th: "เกาหลี", cert: "Embassy Verified", tier: 1 },
  { flag: "🇩🇪", name: "Deutsch", th: "เยอรมัน", cert: "Sworn Translator", tier: 1 },
  { flag: "🇫🇷", name: "Français", th: "ฝรั่งเศส", cert: "Embassy Certified", tier: 1 },
  // Tier 2
  { flag: "🇪🇸", name: "Español", th: "สเปน", cert: "Sworn Translator", tier: 2 },
  { flag: "🇮🇹", name: "Italiano", th: "อิตาลี", cert: "Notarized", tier: 2 },
  { flag: "🇷🇺", name: "Русский", th: "รัสเซีย", cert: "Notarized", tier: 2 },
  { flag: "🇸🇦", name: "العربية", th: "อาหรับ", cert: "Embassy Verified", tier: 2 },
  { flag: "🇵🇹", name: "Português", th: "โปรตุเกส", cert: "Notarized", tier: 2 },
  { flag: "🇳🇱", name: "Nederlands", th: "ดัตช์", cert: "Sworn Translator", tier: 2 },
  // Tier 3 - regional
  { flag: "🇻🇳", name: "Tiếng Việt", th: "เวียดนาม", cert: "Notarized", tier: 3 },
  { flag: "🇮🇩", name: "Indonesia", th: "อินโดนีเซีย", cert: "Notarized", tier: 3 },
  { flag: "🇲🇾", name: "Malay", th: "มาเลย์", cert: "Notarized", tier: 3 },
  { flag: "🇲🇲", name: "မြန်မာ", th: "พม่า", cert: "Notarized", tier: 3 },
  { flag: "🇱🇦", name: "ລາວ", th: "ลาว", cert: "Notarized", tier: 3 },
  { flag: "🇰🇭", name: "ខ្មែរ", th: "เขมร", cert: "Notarized", tier: 3 },
  { flag: "🇵🇭", name: "Filipino", th: "ฟิลิปปินส์ (ตากาล็อก)", cert: "Notarized", tier: 3 },
  { flag: "🇮🇳", name: "हिन्दी", th: "ฮินดี", cert: "Embassy Verified", tier: 3 },
  // Tier 4 - Nordic / EU
  { flag: "🇸🇪", name: "Svenska", th: "สวีดิช", cert: "Sworn Translator", tier: 4 },
  { flag: "🇳🇴", name: "Norsk", th: "นอร์เวย์", cert: "Sworn Translator", tier: 4 },
  { flag: "🇩🇰", name: "Dansk", th: "เดนิช", cert: "Sworn Translator", tier: 4 },
  { flag: "🇫🇮", name: "Suomi", th: "ฟินนิช", cert: "Sworn Translator", tier: 4 },
  { flag: "🇵🇱", name: "Polski", th: "โปแลนด์", cert: "Sworn Translator", tier: 4 },
  { flag: "🇨🇿", name: "Čeština", th: "เช็ก", cert: "Sworn Translator", tier: 4 },
  { flag: "🇹🇷", name: "Türkçe", th: "ตุรกี", cert: "Notarized", tier: 4 },
  { flag: "🇬🇷", name: "Ελληνικά", th: "กรีก", cert: "Notarized", tier: 4 },
  { flag: "🇮🇱", name: "עברית", th: "ฮีบรู", cert: "Notarized", tier: 4 },
  { flag: "🇮🇷", name: "فارسی", th: "เปอร์เซีย", cert: "Notarized", tier: 4 },
  { flag: "🇵🇰", name: "اردو", th: "อูรดู", cert: "Notarized", tier: 4 },
  { flag: "🇧🇩", name: "বাংলা", th: "เบงกาลี", cert: "Notarized", tier: 4 },
] as const;
